export const locale = {
    lang: 'zh2',
    data: {
      'MODALES': {
        'ERROR_DATOS':'发生错误 A-721',
        'VALIDACION':{
          'ERROR1':'您有没有翻译的问题',
          'WARNING-SIN-TRADUCCION':'请添加您的试剂翻译',
          'MODAL-GUARDANDO':'保存无功'
        },
        'TITULO':	'发生错误',
        'TITULOS': {
          'error':	'发生错误',
          'adver':	'警告',
          'aviso':	'警告',
          'opSuc':	'动作完成',
        },
        'ACCIONES': {
          'aceptar':	'确认',
          'cancelar':	'取消',
          'INFORMATIVO': '不要再显示此消息'
        },
        'MENSAJES': {
          'NO_FECH_LAN':'数据不全，选择产品发布日期',
          'NO_RESU_ACTI':'目前没有结果，请稍后再试',
          'OK':'行',
          'Something is wrong': '发生问题',
          'password wrong': '	密码不正确',
          'User does not exist': '您输入的电子邮件未在CultureGO中注册',
          '150':	'已保存',
          // 'Error: user already exist': 'El usuario que intenta registrar ya existe en CulturalGO',
          'CONEX': {
            'SIN': '您的设备失去了互联网连接\n\n要继续使用平台，请将您的设备连接到互联网',
            'CON': '您的设备已恢复互联网连接\n\n现在您可以继续使用平台'
          },
          'WIZARD': {
            'CERTIFICAR' : {
              'RESTRICCIONES': {
                'rest1':	'要访问此部分，必须把调研设置为<b>语言</ b>。',
                'rest2':	'要访问此部分，必须完成前面所有步骤。',
                'rest3':	'要访问此部分，必须<b>安排</ b>启动调研。',
                'rest4':	'要访问此部分，您必须完成<b>邮件发送</ b>，并已启动调研。',
                // 'rest5': 'Para acceder a esta sección es necesario que configure los <b>Demográficos</b> para la encuesta.'
              },
              'IDIOMAS': {
                'NADA':	'您尚未选择语言',
                'NODEFAULT':	'您尚未选择主要语言',
                'NOADICIONAL':	'您尚未选择任何其他语言',
                'COMPLETAR':	'您确定使用当前语言来完成此步骤吗？',
                '210':	'此步骤已完成',
                'COMPLETADO':	'您已完成此步骤',
                'RESTRICCION':	'完成此步骤后，将无法执行此操作',
                'INFORMATIVO': '在本部分中，您将选择调查的主要语言和其他语言，以提供给合作者',
                'ARCHIVOCOMFIRM':'警告！ 一定要在单个操作系统上使用Excel文件，以避免编码冲突。',
                'BOTONTEXTO':'明白了',
              },
              'TEMPLATE': {
                // 'NADA': 'Aún no ha realizado la selección de los idiomas principal y adicionales',
                // 'NODEFAULT': 'Aún no ha seleccionado el idioma principal',
                // 'NOADICIONAL': 'Aún no ha seleccionado idiomas adicionales',
                // 'COMPLETAR': '¿Está seguro de completar el paso con la selección actual de idiomas?',
                // '210': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': '在本部分中，您可以更改模板',
                // 'ARCHIVOCOMFIRM':'¡Advertencia! Asegúrate de trabajar el archivo de Excel en un único sistema operativo para evitar conflictos de codificación',
                // 'BOTONTEXTO':'Enterado',

                // 'TITULO_DESBLOQUEAR': '<span>¿Está seguro de reabrir el paso de idiomas, tenga en cuenta que esto <font color="red">reiniciará</font> su producto actual y borrará toda la información que haya agregado a las secciones?</span>',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'NPS': {
                'NADA': '您尚未创建任何NPS或将选项标记为没有NPS',
                'COMPLETAR': '您确定可以使用当前的NPS完成此步骤吗？',
                '219': '该步骤已成功完成',
                '220': '该步骤已成功完成',
                'COMPLETADO': '您已经完成了此步骤',
                'RESTRICCION': '完成此步骤后，将无法执行此操作',
                'INFORMATIVO': '在本部分中，您可以修改调查的NPS',
                'FALTANTES_TRADUCCIONES': '您尚未完成所有问题的翻译填写',
                'FALTANTES_SECCIONES_ESPECIALES': '你还没有输入特殊部分的键',
                'FALTANTES_RESPUESTAS': '您还无法完成此步骤，所有多项选择题都必须至少有两个答案选项',
                'SIN_PREGUNTAS': '您需要添加至少一个问题才能完成此步骤',
                'SIN_GRUPOS': '您需要添加至少一个包含一个问题的问题组才能完成该步骤',
                'FALTANTES': '您尚未填写NPS'
              },
              'REACTIVOS': {
                'NADA':	'您尚未创建任何反应堆，也未标记没有反应堆的选项',
                'COMPLETAR':	'您确定将当前反应堆标记为已完成吗？',
                '218':	'该步骤已成功完成',
                'COMPLETADO':	'您已经完成了此步骤',
                'RESTRICCION':	'完成此步骤后，将无法执行此操作',
                'INFORMATIVO': '在此部分中，您可以将反应性添加到调查中。',
                'FALTANTES_TRADUCCIONES': '您尚未完成所有问题的翻译填写',
                'FALTANTES_SECCIONES_ESPECIALES': '你还没有输入特殊部分的键',
                'FALTANTES_RESPUESTAS': '您还无法完成此步骤，所有多项选择题都必须至少有两个答案选项',
                'SIN_PREGUNTAS': '您需要添加至少一个问题才能完成此步骤',
                'SIN_GRUPOS': '您需要添加至少一个包含一个问题的问题组才能完成该步骤',
                'FALTANTES': '您尚未完成试剂的填充'
              },
              'FORALL': {
                'NADA': '您尚未完成4ALL练习的填写',
                'COMPLETAR':	'您确定将当前的4ALL Practice 来完成此步骤吗？',
                '212':	'此步骤已完成',
                'COMPLETADO':	'您已完成此步骤',
                'RESTRICCION':	'完成此步骤后，将无法执行此操作',
                'INFORMATIVO': '本节列出了公司开展的活动，其中涉及所有合作者的参与',
                'FALTANTES_TRADUCCIONES': '您尚未完成所有问题的翻译填写',
                'FALTANTES_SECCIONES_ESPECIALES': '你还没有输入特殊部分的键',
                'FALTANTES_RESPUESTAS': '您还无法完成此步骤，所有多项选择题都必须至少有两个答案选项',
                'SIN_PREGUNTAS': '您需要添加至少一个问题才能完成此步骤',
                'SIN_GRUPOS': '您需要添加至少一个包含一个问题的问题组才能完成该步骤',
                'NADA_TRA': '您尚未完成4ALL练习的翻译'
              },
              'CONTROL': {
                'NADA': '您尚未创建任何控制问题或将选项标记为无控制',
                'COMPLETAR': '您确定要完成当前控制问题的步骤吗？',
                '221':	'此步骤已完成',
                'COMPLETADO':	'您已完成此步骤',
                'RESTRICCION':	'完成此步骤后，将无法执行此操作',
                'INFORMATIVO': '在此部分中，您可以修改调查控制问题',
                'FALTANTES_TRADUCCIONES': '您尚未完成所有问题的翻译填写',
                'FALTANTES_SECCIONES_ESPECIALES': '你还没有输入特殊部分的键',
                'FALTANTES_RESPUESTAS': '您还无法完成此步骤，所有多项选择题都必须至少有两个答案选项',
                'SIN_PREGUNTAS': '您需要添加至少一个问题才能完成此步骤',
                'SIN_GRUPOS': '您需要添加至少一个包含一个问题的问题组才能完成该步骤',
                'FALTANTES': '您尚未完成填写控制问题'
              },
              'DEMOGRAFICOS': {
                'NADA': '您尚未选择受众特征',
                'COMPLETAR':	'您确定使用当前的人口统计信息来完成此步骤吗？',
                '213':	'此步骤已成功完成',
                'COMPLETADO':	'您已完成此步骤',
                'RESTRICCION':	'完成此步骤后，将无法执行此操作',
                'FALTANTES_TRADUCCIONES': '您尚未完成所有问题的翻译填写',
                'FALTANTES_SECCIONES_ESPECIALES': '你还没有输入特殊部分的键',
                'FALTANTES_RESPUESTAS': '您还无法完成此步骤，所有多项选择题都必须至少有两个答案选项',
                'SIN_PREGUNTAS': '您需要添加至少一个问题才能完成此步骤',
                'SIN_GRUPOS': '您需要添加至少一个包含一个问题的问题组才能完成该步骤',
                'INFORMATIVO': '本部分建立了人口统计选项，可供调查中的协作者使用。'
              },
              'ABIERTAS': {
                'NADA':	'您尚未创建任何未解决的问题，也未将该选项标记为未解决的问题',
                'COMPLETAR':	'您确定将当前未解决的问题标记为已完成吗？',
                '220':	'该步骤已成功完成',
                '219':	'该步骤已成功完成',
                'COMPLETADO':	'您已经完成了此步骤',
                'RESTRICCION':	'完成此步骤后，将无法执行此操作',
                'INFORMATIVO': '在此部分中，您可以向调查中添加未解决的问题',
                'FALTANTES_TRADUCCIONES': '您尚未完成所有问题的翻译填写',
                'FALTANTES_SECCIONES_ESPECIALES': '你还没有输入特殊部分的键',
                'FALTANTES_RESPUESTAS': '您还无法完成此步骤，所有多项选择题都必须至少有两个答案选项',
                'SIN_PREGUNTAS': '您需要添加至少一个问题才能完成此步骤',
                'SIN_GRUPOS': '您需要添加至少一个包含一个问题的问题组才能完成该步骤',
                'FALTANTES': '您尚未完成填写未解决的问题'
              },
              'ADICIONALES': {
                'NADA':	'您尚未新增任何其他问题，或选择任何其他问题的选项',
                'COMPLETAR':	'您确定使用当前的其他问题来完成此步骤吗？',
                '214':	'此步骤已完成',
                'COMPLETADO':	'您已完成此步骤',
                'RESTRICCION':	'完成此步骤后，将无法执行此操作',
                'FALTANTES_TRADUCCIONES': '您尚未完成所有问题的翻译填写',
                'FALTANTES_SECCIONES_ESPECIALES': '你还没有输入特殊部分的键',
                'FALTANTES_RESPUESTAS': '您还无法完成此步骤，所有多项选择题都必须至少有两个答案选项',
                'SIN_PREGUNTAS': '您需要添加至少一个问题才能完成此步骤',
                'SIN_GRUPOS': '您需要添加至少一个包含一个问题的问题组才能完成该步骤',
                'INFORMATIVO': '在本部分中，您可以向调查添加自定义问题。'
              },
              'COLABORADORES': {
                'NADA': '他尚未将合作者的信息上传到CULTURALGO®。',
                'COMPLETAR':	'您确定使用当前的员工数据库来完成此步骤吗？',
                '211':	'此步骤已完成',
                'COMPLETADO':	'您已完成此步骤',
                'RESTRICCION':	'完成此步骤后，将无法执行此操作',
                'INFORMATIVO': '此部分加载将通过电子邮件向其发送调查邀请的协作者列表。',
                'ACTUALIZAR': '协作者已正确添加到调查中'
              },
              'PROGRAMACION': {
                'NADA': '您尚未安排日期',
                'COMPLETAR':	'您确定使用当前计划日期来完成此步骤吗？',
                'GENERAR':	'您确定把此步骤标示为已完成吗？',
                '215':	'此步骤已完成',
                '217':	'此步骤已完成',  //CERTIFICAR2.0
                'COMPLETADO':	'您已完成此步骤',
                'FECHALANZAMIENTO': '您尚未输入发布日期',
                'RESTRICCION':	'完成此步骤后，将无法执行此操作',
                'INFORMATIVO': '本节确定了启动和发送调查完成提醒的日期。',
                'INFORMATIVO2': '本部分设置发送调查的日期脉冲检查 ',
                'GUARDA-OK':'日期已成功保存',
                'OK':'好',
                'NOT_MESS_COM':'不允许使用此功能',
                'DETEC_CAMBIOS_SECCIONES':'在部分的配置中检测到更改，再次生成调查',
              },
              'ENVIO': {
                'NADA': '您尚未完成发送给协作者的调查邀请电子邮件',
                'NADA_OPCION': '您尚未配置是否通过电子邮件发送邀请',
                'COMPLETAR':	'您确定把此步骤标示为已完成吗？',
                '216':	'此步骤已完成',
                'COMPLETADO':	'您已完成此步骤',
                'RESTRICCION':	'完成此步骤后，将无法执行此操作',
                'INFORMATIVO': '在此部分中，完成调查完成邀请发送。'
              },
              'CONFIRMACION': {
                // 'NADA': 'Aún no ha realizado el envío de la invitación a la encuesta a sus colaboradores',
                // 'NADA_OPCION': 'Aún no ha configurado si el envío de la invitación se hará por correo electrónico',
                // 'COMPLETAR': '¿Está seguro de completar el paso?',
                // '216': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                 'INFORMATIVO': '在此部分中，您可以激活或停用调查',
                // 'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de envío de correos?',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'CIERRE': {
                'NADA': '调查尚未完成。',
                'COMPLETAR':	'您确定将此步骤标示为已完成吗？',
                '217':	'此步骤已完成',
                'COMPLETADO':	'您已完成此步骤',
                'RESTRICCION':	'完成此步骤后，将无法执行此操作',
                'INFORMATIVO': '在本节中，可以查询当前的调查进度以及调查的早日结束。',
                'INFORMATIVO2':'在此部分中，您可以检查启动的每个Pulse Check调查的当前进度 '
              }
            },
            'NOM35': {
              'CENTROS': {
                'AUTOLOGIN': {
                  'TITULO': '警告',
                  'INFO': '警告\n\n您的会话将关闭，平台将继续登录为所选工作中心。\n\n您确认要登录为选定的工作中心吗？',
                  'INFOODS': '警告\n\n您的会话将关闭，平台将继续作为所选公司登录。\n\n您确认登录为所选公司吗？'
                }
              }
            },
            'FOCUS':{
              'MODAL-AUNAUTORIZACION':'尚未授权',
              'BTN-ENTERADO':'输入',
              'MODAL-AUTORIZACION':'您的调查已发送到验证',


            },
          }
        },
        'ERRORES': {
          'Ocurrió un error desconocido': '您的计算机或设备与平台的连接失败，请稍后再尝试访问',
          '102': '您输入的电子邮件未在CultureGO中注册',
          '103': '密码不正确',
          'verifyToken_3': '<span>该平台最近进行了更新，因此，为避免丢失信息，我们将关闭您的会话。<br><br>为确保平台的正常运行，<font color="red">您的浏览器将自动更新</font></span>',
          'tokenActLogin': '<span>该平台最近进行了更新，因此并为确保平台正常运行，<font color="red">您的浏览器将自动更新</font>，稍后您可以正常访问该平台</span>',
          'Demo keys out of stock': '调查演示用户已经筋疲力尽',
          'Keys Out Of Stock': '调查演示用户已经筋疲力尽',
          'Error: Please Recreate Survey':'在问题中检测到更改\n\n 要继续，请重新创建调查',
          'IT Manager Not Found':'电子邮件未发送给IT经理\n\n请输入电子邮件并手动发送。',
          'NO_PROCC_PROD_ASO':'相关产品目前尚未处理',
          'ERR_PROCC_PROD_ACT':'在 SQL 中更新用户时出错',
          '300':'输入的邮箱没有访问权限',
        },
        'ELIMINAR':{
          'MENSAJETEXTO1': '<span>确认处置公司 ',
          'MENSAJETEXTO2': ', 在文本框中输入公司名称</span>',
          'SALIR': '出口',
          'VALIDAR': '确认公司',
          'ERRORNOMBREEMPRESA': '输入的公司名称与要删除的公司名称不匹配',
          'MENSAJE': '你确定吗？\n\n您即将删除公司 ',
          'CANCELAR': '取消',
          'CONFIRMAR': '是的，删除',
          'SUCCES': '公司被淘汰',
          'CERRAR': '关'
        }
      }
    }
};
